// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgSubscript = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.354 14.5v-.665l1.553-1.438q.198-.192.332-.345.136-.154.207-.3.07-.15.07-.322a.57.57 0 0 0-.326-.546.75.75 0 0 0-.343-.077.7.7 0 0 0-.35.082.56.56 0 0 0-.23.232.75.75 0 0 0-.08.36h-.876q0-.429.194-.744a1.3 1.3 0 0 1 .543-.488 1.8 1.8 0 0 1 .806-.172q.468 0 .816.166.35.164.543.456.195.292.194.669 0 .247-.098.488-.096.24-.343.535a8 8 0 0 1-.697.7l-.637.625v.03h1.832v.754zM5.04 4.273l1.92 3.196h.068l1.93-3.196h1.803L8.073 8.636 10.805 13H8.972L7.03 9.825h-.068L5.018 13H3.194l2.757-4.364-2.723-4.363z"
    />
  </svg>
);
export const SubscriptIcon = forwardRef(SvgSubscript);
